import React,{useState,useEffect} from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import ListDocument from './component/document/ListDocument';
import PupUpNewDocument from './component/popupbom/PupUpNewDocument';
import PageHeader from '../../components/pageheader/PageHeader';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';

function Documents() {
  useEffect(()=>{
  const userId=  sessionStorage.getItem("userId")
 
  },[])

  return (
    <div>
      <NavbarUser />
      <main className="container mx-auto px-4 py-8" style={{ padding: 10, backgroundColor: '#f7f7f7' }}>
        <PageHeader
          title="Document List All"
          subtitle="Journal list all and manage document workflow"
          icon={NoteAddRoundedIcon}
          color="#8e24aa"
          actions={<PupUpNewDocument />}
        />
        <div>
          <ListDocument />
        </div>
      </main>
    </div>
  )
}

export default Documents